import React from 'react';
import imgStep1 from 'assets/images/lightbox/step-1.png';
import imgStep0 from 'assets/images/lightbox/pegar-step-0.png';
import imgStep2 from 'assets/images/lightbox/step-2.png';
import PropTypes from 'prop-types';

const PopupStepsEcommerce = ( {category=""}) => {

    return (
       <>
      {category=="ecommerce" &&
        <div id="message-popup-alert" className="white-popup message-popup-alert mcl">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-12">
                                <p className="text-center mb-4">Para disfrutar de tus <br/> cupones para compras online sigue estos pasos:</p> 
                            </div>
                            <div className="col-12">
                                <ol>
                                    <li><img src={imgStep0} className="float-left"/> Selecciona y copia el código del cupón que desea canjear.</li>
                                    <li><img src={imgStep1} className="float-left"/> Selecciona la opción de “ir a Metro.pe“ o “ir a APP Metro“.</li>
                                    <li><img src={imgStep2} className="float-left"/> Agrega los productos a tu carrito y pega el código del cupón.</li>
                                </ol>
                            </div>
                            <div className="col-12 p-1">
                                <p className="text-center remember"> <strong>Sólo un cupón en cada pedido</strong>.</p>
                            </div>                      
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }
        </>
    )
};
PopupStepsEcommerce.propTypes = {
    category: PropTypes.string
};

export default PopupStepsEcommerce ;